import { signInWithGoogle } from '../../auth/lib/firebase';

export const handleNativeLoginResponse = (payload: unknown) => {
  console.log('LOGIN_RESPONSE', payload);
  try {
    const { token } = validatePayload(payload);
    signInWithGoogle(token);
  } catch (error) {
    console.error('Error parsing payload', error);
  }
};

function validatePayload(payload: unknown) {
  const token = (payload as Record<string, unknown>)?.token as string;
  if (!token) {
    throw new Error('No token provided.');
  }
  return { token };
}
